import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons';

type Props = {
    message: any;
    openMessage: Function;
    onStarClick: Function;
    onMoveMessageClick?: Function;
    onSetMessageClick?: Function;
};

const EmailMessageItem = (props: Props) => {
    const [message, setMessage] = useState<any>({})
    const [star, setStar] = useState<boolean>(false)
    const [load, setLoad] = useState<boolean>(false)
    const [showBtnOptions, setShowBtnOptions ] = useState<boolean>(false);

    const openMessage = (e: any) => {
        console.log(e, message);
        
        const dataObject: any = {}
        message.isRead = true;
        dataObject.CustomerPhoneNumber = props.message.customerPhoneNumber;
        if (props.message.userId) {
            dataObject.UserId = props.message.userId;
        } else {
            
        }
      //  if (e.target.className.includes('star')) {
      //      return;
      //  } else {
            
      //  }

        console.log('props.message', props.message);
        props.openMessage(props.message);
    }

    const onStarClick = async () => {
        
        const dataObject: any = {};
        if (props.message.userId) {
            dataObject.UserId = props.message.userId;
        } else {
            dataObject.CustomerPhoneNumber = props.message.customerPhoneNumber;
        }

        if (message) {
            message.star = !message.star;
            await props.onStarClick(message.star, dataObject);
            setStar(message.star);
            
        }
    }
    
    const onMoveMessage = () => {
        // setShowBtnOptions(false);
        // props.onMoveMessageClick(message.id)
    }
    const onSetMessage = () => {
        // setShowBtnOptions(false);
        // props.onSetMessageClick(message.id)
    }

    useEffect(()=>{
        if(load){
            console.log('message', message);
            const m = props.message;
            if(star){
                m.star = true;
            }
            else{
                m.star = false;
            }
            setMessage(m);
        }
        

    }, [star])

    useEffect(()=>{
        //console.log('message init', props.message);
        const m = props.message;
        m.hasImage = false;
        m.hasFile = false;
        m.messageText = m.text;
        if (m.text && m.text.indexOf('image;') > -1) {
            m.hasImage = true;
            m.imageName = 'image';
            m.messageText = '';
            // m.imageName = m.text.replace('image;', '')
        }
        if (m.text && m.text.indexOf('document;') > -1) {
            m.hasFile = true;
            m.fileUrl = m.text.replace('document;', '');
            m.fileName = m.fileUrl.substring(m.fileUrl.lastIndexOf('/')+1);
            m.messageText = '';
        }
        
        setMessage(m);
        setLoad(true);
    }, []) 

    return (
        <>
        <div className="data-card client-item" >
            <div className="data-card-body flex-start pointer">
                <div className="cell checkbox" onClick={() => onStarClick()}>
                    <div className={`icon star${message && message.star ? ' selected': ''}`}></div> 
                </div>
                <div className="cell"  onClick={(e: any) => openMessage(e)}>
                    <div className={message && message.isRead?"description cell-value":"description cell-value read"} >
                        {message.senderUserId==null || message.receiverUserId==null?<div className='iconDiv'><FontAwesomeIcon icon={faUser} /></div>:""}
                        {message.customerName}
                    </div>
                    <div className="description">
                        {/* {message.customerPhoneNumber} */}
                        {message.customerPhoneNumber?message.customerPhoneNumber.replace(/^972/, "0"):""
                    }
                    </div>
                </div>
                <div className="cell long description"  onClick={(e: any) => openMessage(e)}>
                    <div className={message && message.isRead?"description cell-value":"description cell-value read"} >
                        <div className={`${message.hasImage ? '' : 'hide'}`}>
                            <div className="icon document-icon"></div>
                                {message.imageName}
                        </div>
                        <div className={`${message.hasFile ? '' : 'hide'}`}>
                            <div className="icon document-icon"></div>
                                {message.fileName}
                        </div>
                        <div className='message-text'>
                            {message.messageText}
                        </div>
                    </div>
                </div>
                <div className="cell star"  onClick={(e: any) => openMessage(e)}>
                </div>
                <div className="cell"  onClick={(e: any) => openMessage(e)}>
                    <div className={message && message.isRead?"description cell-value":"description cell-value read"}>
                        {message.date}
                    </div>
                    <div className="description">
                        {message.time}
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default EmailMessageItem;